<div class="full column">
  @if (dimensionMapping.length > 0) {
    @if (displayHelpText) {
      <div class="lm-dimensions-mapping-help-container">
        <svg class="icon icon-info" style="top: 0px !important" focusable="false" aria-hidden="true" role="presentation">
          <use [attr.xlink:href]="'#icon-info'"></use>
        </svg>
        <p style="flex-:1 wrap">{{helpText}}</p>
      </div>
    }
    @for (dimension of dimensionMapping; track dimension) {
      <lm-cube-dimension-row
        [cubeBusClass]="cubeBusClass"
        [dimension]="dimension"
        [structures]="structures"
        [hasReportingBasis]="hasReportingBasis"
        [topNodeBaseValue]="topNodeBaseValues ? topNodeBaseValues[dimension.id] : undefined"
        >
      </lm-cube-dimension-row>
    }
  } @else {
    <div soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
  }
</div>
